// Feature switch: practitioner "years of experience" on CLIENT-facing booking
// surfaces (practitioner cards, search results, profile dialog). Flip to true
// to show it again. Staff/admin practitioner screens are not affected.
// `as boolean` keeps the flag's type widened so the gated conditions below it
// don't trip @typescript-eslint/no-unnecessary-condition while it is off.
export const SHOW_PRACTITIONER_EXPERIENCE_TO_CLIENTS = false as boolean;

export const AUTH_ROUTES = {
  STAFF_LOGIN: '/login',
  CLIENT_LOGIN: '/client/login',
  INVITE_ACCEPT: '/invite/accept',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_CONFIRM: '/reset-password/confirm',
} as const;

export const CLINICAL_LANDING = '/app/clients';
export const CLIENT_DASHBOARD = '/client/dashboard';

export const QUERY_DEFAULTS = {
  STALE_TIME: 5 * 60 * 1000,
  GC_TIME: 30 * 60 * 1000,
  RETRY: 1,
} as const;

export const LIST_QUERY_DEFAULTS = {
  // Admin list screens: keep previous page's data visible while fetching next.
  // 5 min so navigating away to a session/case-report/assessment editor and
  // back doesn't trigger a remount refetch (perceived as a flash/"reload").
  // Live updates arrive via realtime events that invalidate the relevant keys.
  STALE_TIME: 5 * 60 * 1000,
} as const;
